import { EMAIL_REGEX, PHONE_FORMAT_REGEX, ZIP_CODE_REGEX } from '@jebel/constants';
/**
 * Transform the given `text` from `camelCase`, `snake_case` and `PascalCase` to readable text.
 * @param text Given text on `camelCase`, `snake_case` or `PascalCase` format.
 * @returns Readable text transforming the given `text`.
 */
export function humanizeText(text) {
    return text
        .replace(/^[\s_]+|[\s_]+$/g, '')
        .replace(/^(\w+)([A-Z])/g, '$1 $2')
        .replace(/[_\s]+/g, ' ')
        .replace(/^[a-z]|\s\w/g, selected => selected.toUpperCase());
}
/**
 * Hidden overflow `text` based on the given `size`.
 * @param text Given `text` overflowed.
 * @returns Hidden `text` when overflowed.
 * @example "Hello wor..."
 */
export function overlapText(text, options) {
    var _a, _b;
    const separator = (_a = options === null || options === void 0 ? void 0 : options.separator) !== null && _a !== void 0 ? _a : '...';
    const size = (_b = options === null || options === void 0 ? void 0 : options.size) !== null && _b !== void 0 ? _b : 20;
    if (text.length < size) {
        return text;
    }
    return text.slice(0, size) + separator;
}
/**
 * Checks if the given string is a valid email address.
 *
 * @param value - The string to be checked.
 * @returns `true` if the string is a valid email address, otherwise `false`.
 */
export function isEmail(value) {
    return EMAIL_REGEX.test(value);
}
/**
 * Checks if the given string is a valid zip code.
 *
 * @param value - The string to be checked.
 * @returns `true` if the string is a valid zip code, otherwise `false`.
 */
export function isZipCode(value) {
    return ZIP_CODE_REGEX.test(value);
}
/**
 * Checks if the given string value matches the format of a phone number.
 *
 * @param value - The string to be tested as a phone number.
 * @returns `true` if the value matches the phone number format, otherwise `false`.
 */
export function isPhoneNumber(value) {
    return PHONE_FORMAT_REGEX.test(value);
}
